import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { TemplateService } from '../services/template.service';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { AddTemplateComponent, AddTemplateDialogData } from './add-template/add-template.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { CommonTemplateService } from '../services/common-template.service';
import { PlantillaTemplate } from 'app/modules/common/entities/plantilla-template.model';

@Component({
    selector: 'app-common-template',
    templateUrl: './common-template.component.html',
    styleUrls: ['./common-template.component.scss'],
    standalone: false
})
export class CommonTemplateComponent implements OnInit, AfterViewInit {

    // name displayed on the top
    @Input("app-name") appName: string;

    // controller name for this plantilla template
    @Input("controller-name") controllerName: string;

    // check if a record is edditable
    @Input() edditable = false;

    // data source to be diplayed in the table
    public dataSource = new MatTableDataSource<PlantillaTemplate>();

    IsLoading = false;
    IsUpdating = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    public displayedColumns = [ 'nombre','action'];

    constructor(
        private templateService: CommonTemplateService,
        public dialog: MatDialog,
        private sharedService: SharedService) { }

    ngOnInit(): void {
        this.getTemplates();
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
    }


    /**
     * Open add template dialog to add new template
     */
    addNewTemplate(): void {
        // open add template dialog
        const dialogRef = this.dialog.open<AddTemplateComponent, AddTemplateDialogData, any>(
            AddTemplateComponent,
            {
                width: '400px',
                data: {
                    controller: this.controllerName
                }
            }
        );

        // get new template names list on closing dialog
        dialogRef.componentInstance.saved.subscribe(() => {
            this.getTemplates();
        });
    }


    /**
     * Open a dialog to edit the given template
     * @param template Template to be editted
     * @param file File of the template
     */
    editExistingTemplate(template: PlantillaTemplate, file: string): void {
        const dialogRef = this.dialog.open<AddTemplateComponent, AddTemplateDialogData, any>(
            AddTemplateComponent,
            {
                width: '400px',
                data: {
                    controller: this.controllerName
                }
            }
        );

        // set dialog properties
        dialogRef.componentInstance.IsUpdate = this.IsUpdating;
        dialogRef.componentInstance.Template = template;
        dialogRef.componentInstance.TemplateFile = file;

        // handle dialog save
        dialogRef.componentInstance.saved.subscribe(() => {
            this.getTemplates();
        });

        // handle dialog close
        dialogRef.afterClosed().subscribe(() => {
            this.IsUpdating = false;
        });
    }


    /**
     * Get all templates from server
     */
    getTemplates(): void {
        this.templateService.getTemplates(this.controllerName)
            .subscribe(res => {
                if (res.code === 0) {
                    this.dataSource.data = res.result;
                    this.dataSource.paginator = this.paginator;
                }
            }, err => {
                this.sharedService.ShowSnackBar('Error al cargar la lista de plantillas', 'Okay', 2500);
                console.error(err);
            });
    }


    /**
     * Delete template
     * @param template Template to be deleted
     */
    confirmDialog(template: PlantillaTemplate): void {
        // confirm before deleting
        const message = `¿Seguro que quieres hacer esto?`;
        const dialogData = new ConfirmDialogModel('Confirmar acción', message);
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });

        // delete after confirmation
        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                this.templateService.deleteTemplate(template.plantillaId, this.controllerName)
                    .subscribe(() => {
                        this.getTemplates();
                        this.sharedService.ShowSnackBar('Borrado exitosamente', 'Okay', 2500);
                    });
            }
        });
    }


    /**
     * Edit template
     * @param template Template
     */
    editTemplate(template: PlantillaTemplate): void {
        this.IsUpdating = true;
        this.templateService.downloadTemplate(template.plantillaId, this.controllerName).subscribe(res => {
            if (res.code === 0) {
                const file = res.result.file;
                this.editExistingTemplate(template, file);
            } else {
                this.sharedService.ShowSnackBar('No se encontró la plantilla', '', 2000);
                this.editExistingTemplate(template, '');
            }
        });
    }


    /**
     * Download template
     * @param template User selected template
     */
    downloadTemplate(template: any): void {
        this.templateService.downloadTemplate(template.plantillaId, this.controllerName).subscribe((res) => {
            if (res.code === 0) {
                const file = res.result.file;
                const fileName = res.result.fileName;
                const link = document.createElement('a');
                link.setAttribute('type', 'hidden');
                link.href = 'data:application/octet-stream;base64,' + file;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                this.sharedService.ShowSnackBar('No se encontró la plantilla', '', 2000);
                console.error(res.message);
            }
        }, error => {
            this.sharedService.ShowSnackBar('No se encontró la plantilla', 'Okay', 2000);
            console.error(error);
        });
    }

}
